import { Sphere } from '@react-three/drei';
import { useSetRef } from '@artica/hooks';

export default function Sun() {
  return (
    <Sphere args={ [75] } ref={ useSetRef('dysonsun') }>
      <meshBasicMaterial
        opacity={ 0.9 }
        depthWrite={ false }
        transparent
      />
    </Sphere>
  );
};